// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__DPsyr","header":"MessagesList_header__2mcfs","chat":"MessagesList_chat__VzalP"};